import { Menu } from "antd";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import LeftSubMenu from "./LeftSubMenu";
import LeftMenuItem from "./LeftMenuItem";

const getInitialMenuOpenKeys = (items, keys) => {
  const item = items[0] || {};
  if (item.key) {
    keys.push(item.key);
  }
  if (item.submenus) {
    getInitialMenuOpenKeys(item.submenus, keys);
  }
};

class LeftMenu extends Component {
  constructor(props) {
    super(props);
    this.rootSubmenuKeys = [];
    this.state = {
      openKeys: [],
      selectedKeys: [],
      reduced: true
    };
  }

  renderContent() {
    const { items } = this.props;

    const menuItems = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type === "menu" && item.submenus) {
        menuItems.push(<LeftSubMenu key={item.key} item={item} />);
      }

      if (item.type === "kpi") {
        menuItems.push(<LeftMenuItem key={item.key} item={item} />);
      }
    }

    return menuItems;
  }

  onOpenChange = (openKeys, a, b) => {
    if (openKeys.length < this.state.openKeys.length) {
      this.setState({ openKeys: openKeys });
      return;
    }

    const lastKey = openKeys[openKeys.length - 1] || "";
    const lastKeyLevel = lastKey.split("@").length - 1;
    const filterdOpenKeys = openKeys.filter(key => {
      if (key === lastKey) return true;
      const keyLevel = key.split("@").length - 1;
      return keyLevel < lastKeyLevel;
    });

    this.setState({ openKeys: filterdOpenKeys });
  };

  onSelect = key => {
    this.setState({ selectedKeys: [key.key] });
  };
  render() {
    const defaultOpenKeys = [];
    getInitialMenuOpenKeys(this.props.items, defaultOpenKeys);

    const reduced = this.state.reduced ? "reduced" : null;
    const defaultSelectedKeys = [(defaultOpenKeys[defaultOpenKeys.length - 1] || "") + "-dashboard"];
    return (
      <div className="p-flex-col p-pdg-left-20 p-menu-left">
        <div
          className={`p-content-page-center-header-buttons-item p-btn p-btn-orange`}
          style={{ margin: "0 auto 10px" }}
          onClick={() => this.setState({ reduced: this.state.reduced ? false : true })}
        >
          {this.state.reduced ? (
            <Fragment>
              <span className="icon-arrow-right p-mrg-right-s" style={{ color: "#fff" }}></span> Agrandir le menu
            </Fragment>
          ) : (
            <Fragment>
              <span className="icon-arrow-left p-mrg-right-s" style={{ color: "#fff" }}></span> Réduire le menu
            </Fragment>
          )}
        </div>
        <Menu
          className={`p-sidebar.custom-stats stats-left-menu ${reduced}`}
          openKeys={this.state.openKeys.length === 0 ? defaultOpenKeys : this.state.openKeys}
          onOpenChange={this.onOpenChange}
          onSelect={this.onSelect}
          selectedKeys={this.state.selectedKeys.length === 0 ? defaultSelectedKeys : this.state.selectedKeys}
          mode="inline"
        >
          {this.renderContent()}
        </Menu>
      </div>
    );
  }
}

LeftMenu.propTypes = {
  items: PropTypes.array
};

export default LeftMenu;



// WEBPACK FOOTER //
// src/modules/stats/components/LeftMenu/LeftMenu.js